// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Macao from '../_raw/flag/icon_flag_macao.png';

export default () => <img src={Macao} alt="Macao" />;
